import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import VideoGaleryDetailsPost from './VideoGaleryDetailsPost';

function VideoGaleryDetails(props) {
    const { layout } = props;
    let content;
    if (layout === 'classic') {
        content = (
            <VideoGaleryDetailsPost layout={layout} />
        );
    } else if (layout === 'full') {
        content = (
            <div className="row justify-content-center">
                <div className="col-md-12 col-lg-8 col-xl-8">
                    <VideoGaleryDetailsPost layout={layout} />
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            {content}
        </React.Fragment>
    );
}

VideoGaleryDetails.propTypes = {
    layout: PropTypes.oneOf(['classic', 'full']),
};

VideoGaleryDetails.defaultProps = {
    layout: 'classic',
};
const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(VideoGaleryDetails);
